import { IManagableObject } from "../../admin-panel/IManagableObject";

export class SharedObjectModel implements IManagableObject
{
  Id: number = 0;
  IsChecked: boolean = false;
  Name: string = "";

  init(data?: any): void
  {
      if (data)
      {
          this.Id = data["id"];
          this.IsChecked = data["isShared"];
          this.Name = data["name"];
      }
  }

  static fromJS(data: any): SharedObjectModel
  {
    let result = new SharedObjectModel();
    result.init(data);
    return result;
  }
}
